import React from 'react'
import useSwr from 'swr'
import { API_URL } from '@/utils/constants'
import Wallet from '@/utils/wallet'
import featureFlags from '@/utils/feature-flags'
import axios from 'axios'

const fetcher = async ([_url, address]: any) => {
	if (!address) {
		return []
	}

	try {
		const { data } = await axios.get(`${API_URL}/wallet/${address}/rune-balance`)

		// @ts-ignore
		return data
	} catch {
		return { collections: [] }
	}
}

export default function useRuneBalance(address?: string): {
	data: any[]
	isLoading: boolean
} {
	const disabled = featureFlags('app::disable_runes')
	const a = address || Wallet.getTaprootAddress()

	const { data, isLoading } = useSwr(disabled ? null : ['/rune-balance', a], fetcher)

	const runes = React.useMemo(() => {
		if (!data || !Array.isArray(data)) {
			return []
		}

		return data.map((r) => {
			return {
				...r,
				balanceUSD: 0,
				satoshiPrice: 0,
				overall_balance: r.amount,
				ticker: r.name,
				type: 'rune',
				rune_id: r.rune_id,
				collection: { symbol: r.symbol, ...r.collection }
			}
		})
	}, [data])

	return { data: disabled ? [] : runes, isLoading: disabled ? false : isLoading }
}
